import { elegir } from '../ui/layout-variant.tsx';
import { RegistroMobile } from './Registro.mobile.tsx';
import { RegistroDesktop } from './Registro.desktop.tsx';

export default elegir(RegistroMobile, RegistroDesktop);
